// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';

// Components
import Header from './components/Header/Header';
import AboutUs from './components/About/AboutUs';
import Experience from './components/experience/experience';
import Services from './components/services/services';
import Project from './components/Project/project';
import Footer from './components/footer/footer';
import Blog from './components/blog';
import ListProject from './components/Project/professional-info-card-design';
import ResponsiveMobile from './components/Project/ResponsiveMobile';
import VideoShorts from './components/frontend-developer-builds-custom-website';
import PageNotf from "./components/404";
import Wcts from "./components/webdesign-company-in-trichy";
import Wdcts from "./components/website-design-company-in-trichy";
import Bwcts from "./components/best-webdesign-in-trichy";
import Bestweb from "./components/best-webdesign-company-in-trichy";
import WebsiteDev from "./components/website-development-company-in-trichy";




function App() {
  return (
    <Router>
      <Header />
      <Routes>
        {/* Home page */}
        <Route
          path="/"
          element={
            <>
              <AboutUs />
              <Project />
              <Experience />
              <Services />
              
              <Footer />
            </>
          }
        />

        {/* Project pages */}
        <Route path="/professional-info-card-design" element={<ListProject />} />
         <Route
          path="/responsive-mobile-menu-html-css-javascript"
          element={<ResponsiveMobile />}
        />
        <Route
          path="/frontend-developer-builds-custom-website"
          element={<VideoShorts />}               
        />
        <Route
          path="/webdesign-company-in-trichy"
          element={<Wcts />}               
        />
             <Route
          path="/website-design-company-in-trichy"
          element={<Wdcts />}               
        />
          <Route
          path="/best-webdesign-in-trichy"
          element={<Bwcts />}               
        />
             <Route
          path="/best-webdesign-company-in-trichy"
          element={<Bestweb />}               
        />
             <Route
          path="/website-development-company-in-trichy"
          element={<WebsiteDev />}               
        />
            
        {/* Blog page */}
        <Route path="/blog" element={<Blog />} />
        {/* ❌ Page Not Found - MUST be last */}  
        <Route path="*" element={<PageNotf />} />
      </Routes>
    </Router>
  );
}

export default App;
